export const version = "bytes/5.4.0";
//# sourceMappingURL=_version.js.map